import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import type { SxProps, Theme } from '@mui/material/styles';
import { SIDENAV_WIDTH } from 'domains/reporter/RichTextEditor/plugins/inlineBookmark/constants';
import { Spacings, Colors, Sizes } from 'styles';

const defaultContent = <Typography>SIRONA</Typography>;

type GenericAppBarProps = {
  content?: React.ReactNode;
  children?: React.ReactNode;
  fixed?: boolean;
  sx?: SxProps<Theme>;
  toolbarSx?: SxProps<Theme>;
};

export default function GenericAppBar({
  content = defaultContent,
  children,
  fixed = false,
  sx,
  toolbarSx,
}: GenericAppBarProps) {
  return (
    <AppBar
      position={fixed ? 'fixed' : 'relative'}
      elevation={0}
      sx={{
        zIndex: 8,
        background: Colors.toolbar,
        borderBottom: `1px solid ${Colors.gray2}`,
        height: Sizes.toolbarHeight,
        pl: `calc(env(titlebar-area-x, 0) - ${SIDENAV_WIDTH}px + ${Spacings.medium}px)`,
        ...sx,
      }}
    >
      <Toolbar
        disableGutters
        variant="dense"
        sx={{
          height: Sizes.toolbarHeight,
          ...toolbarSx,
        }}
      >
        {children ?? content}
      </Toolbar>
    </AppBar>
  );
}
